import { Environment } from '../constants/env'

const SHEETGO_USER_AUTH_ENCRYPT_KEY = 'SHEETGOWEBSITE'
const SHEETGO_APP_STATE_ENCRYPT_KEY = '4PZ$T4T3$'
const SHEETGO_WEBSITE = ['www.sheetgo.com', 'sheetgo.com']

const PLAN_YEAR_SUFFIX = '2023'
const DEFAULT_INTERCOM_APP_ID = 'adhexofg'
const MAX_CELLS_TRANSFER_FORMAT = 350000

const envs = {
    [Environment.PROD]: {
        name: Environment.PROD,
        appURL: 'https://app.sheetgo.com',
        apiURL: 'https://api.sheetgo.com',
        wsURL: 'https://api.sheetgo.com',
        msappURL: 'https://msapp.sheetgo.com',
        formsAppURL: 'https://forms.sheetgo.com',
        dashboardsAppURL: 'https://dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '2631381',
        clarityId: 'n7q7fux3ep',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: new RegExp(
            '^https://n-7ixdqsk3ntqkmodnjzyunwcrhtieg7y7tpckjey-' +
            '(\\d+)lu-script\\.googleusercontent\\.com(?:/userCodeAppPanel)?$'
        ),
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.LEGACY]: {
        name: Environment.LEGACY,
        appURL: 'https://legacy.sheetgo.com',
        apiURL: 'https://legacy-api.sheetgo.com',
        wsURL: 'https://legacy-api.sheetgo.com',
        msappURL: 'https://legacy-msapp.sheetgo.com',
        formsAppURL: 'https://legacy-forms.sheetgo.com',
        dashboardsAppURL: 'https://legacy-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '217155',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.NEW]: {
        name: Environment.NEW,
        appURL: 'https://new.sheetgo.com',
        apiURL: 'https://new-api.sheetgo.com',
        wsURL: 'https://new-api.sheetgo.com',
        msappURL: 'https://msapp.sheetgo.com',
        formsAppURL: 'https://new-forms.sheetgo.com',
        dashboardsAppURL: 'https://new-dashboards.sheetgo.com',
        oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.STAGING]: {
        name: Environment.STAGING,
        appURL: 'https://staging.sheetgo.com',
        apiURL: 'https://staging-api.sheetgo.com',
        wsURL: 'https://staging-api.sheetgo.com',
        msappURL: 'https://staging-msapp.sheetgo.com',
        formsAppURL: 'https://staging-forms.sheetgo.com',
        dashboardsAppURL: 'https://staging-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oneSignalAppId: '0d785d26-d366-4245-a50f-152a98408175',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.DEV]: {
        name: Environment.DEV,
        appURL: 'https://dev.sheetgo.com',
        apiURL: 'https://dev-api.sheetgo.com',
        wsURL: 'https://dev-api.sheetgo.com',
        msappURL: 'https://dev-msapp.sheetgo.com',
        formsAppURL: 'https://dev-forms.sheetgo.com',
        dashboardsAppURL: 'https://dev-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.BETA]: {
        name: Environment.BETA,
        appURL: 'https://beta.sheetgo.com',
        apiURL: 'https://beta-api.sheetgo.com',
        wsURL: 'https://beta-api.sheetgo.com',
        msappURL: 'https://beta-msapp.sheetgo.com',
        formsAppURL: 'https://beta-forms.sheetgo.com',
        dashboardsAppURL: 'https://beta-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.ALPHA]: {
        name: Environment.ALPHA,
        appURL: 'https://alpha.sheetgo.com',
        apiURL: 'https://alpha-api.sheetgo.com',
        wsURL: 'https://alpha-api.sheetgo.com',
        msappURL: 'https://alpha-msapp.sheetgo.com',
        formsAppURL: 'https://alpha-forms.sheetgo.com',
        dashboardsAppURL: 'https://alpha-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
    },
    [Environment.LOCAL]: {
        name: Environment.LOCAL,
        appURL: 'https://local.sheetgo.com',
        /** Default LOCAL backend config */
        apiURL: 'https://local-api.sheetgo.com',
        wsURL: 'https://local-api.sheetgo.com',
        msappURL: 'https://local-msapp.sheetgo.com',
        formsAppURL: 'https://local-forms.sheetgo.com',
        dashboardsAppURL: 'https://local-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac9f2w3eFaSzHWn5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        )
        /** Alternative PROD backend for development */
        // apiURL: 'https://api.sheetgo.com',
        // wsURL: 'https://api.sheetgo.com',
        // msappURL: 'https://msapp.sheetgo.com',
        // formsAppURL: 'https://forms.sheetgo.com',
        // dashboardsAppURL: 'https://dashboards.sheetgo.com',
        // barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        // oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        // oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        // oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        // geolocationApiKey: '726f901fb0da17',
        // oktaIssuerDomain: 'https://dev-21489187.okta.com',
        // oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        // hotjarId: '2631381',
        // clarityId: 'n7q7fux3ep',
        // reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp'
        // ancestorsRegex: new RegExp(
        //     '^https://n-7ixdqsk3ntqkmodnjzyunwcrhtieg7y7tpckjey-' +
        //     '(\\d+)lu-script\\.googleusercontent\\.com(?:/userCodeAppPanel)?$'
        // ),
        // dynamsoftKey: (
        //     'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
        //     'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
        //     'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        // )
    }
}

if (window.location.hostname === 'localhost') {
    window.location.replace(envs[Environment.LOCAL].appURL)
}

const settings = Object.values(envs)
    .find(env => env.appURL.includes(window.location.hostname))

const { name: currentEnv } = settings

const isLocalEnv = currentEnv === envs[Environment.LOCAL].name
const prodEnvSettings = envs[Environment.PROD]
const legacyEnvSettings = envs[Environment.LEGACY]
const isProdEnv = [Environment.PROD, Environment.PROD2, Environment.NEW].includes(currentEnv)

/**
 * Test if a link is for the Sheetgo website.
 *
 * @param {string} link - A given link.
 * @returns {boolean} If hostname is from website.
 */
const isLinkFromSheetgoWebsite = (link) => {
    const { hostname } = new URL(link)
    return SHEETGO_WEBSITE.includes(hostname)
}

const {
    appURL,
    apiURL,
    wsURL,
    msappURL,
    barcodeDetectorURL,
    formsAppURL,
    dashboardsAppURL,
    oneSignalAppId,
    oauthClientId,
    oauthClientIdAlt,
    geolocationApiKey,
    oktaIssuerDomain,
    oktaClientId,
    hotjarId,
    clarityId,
    reCaptchaApiKey,
    ancestorsRegex,
    intercomAppId,
    dynamsoftKey,
    openAiClientId
} = settings

/**
 * Check if the current origin is a valid app ancestor.
 *
 * @param {string} origin - The ancestor origin.
 * @returns {boolean} Representing if the ancestor origin is valid or not.
 */
const isURLFromValidAppIframeAncestor = (origin) => Boolean(origin && origin.match(ancestorsRegex))

export {
    SHEETGO_USER_AUTH_ENCRYPT_KEY,
    SHEETGO_APP_STATE_ENCRYPT_KEY,
    PLAN_YEAR_SUFFIX,
    currentEnv,
    appURL,
    msappURL,
    formsAppURL,
    dashboardsAppURL,
    isLocalEnv,
    apiURL,
    wsURL,
    oneSignalAppId,
    oauthClientId,
    oauthClientIdAlt,
    geolocationApiKey,
    oktaIssuerDomain,
    oktaClientId,
    hotjarId,
    clarityId,
    prodEnvSettings,
    legacyEnvSettings,
    isProdEnv,
    barcodeDetectorURL,
    reCaptchaApiKey,
    intercomAppId,
    dynamsoftKey,
    openAiClientId,
    isURLFromValidAppIframeAncestor,
    isLinkFromSheetgoWebsite,
    MAX_CELLS_TRANSFER_FORMAT
}
